import { InjectedConnector } from "@web3-react/injected-connector";

export const injected = new InjectedConnector({
  supportedChainIds: process.env.REACT_APP_TEST_MINT ? [84532] : [8453],
});
